import { render, staticRenderFns } from "./SubtitlesNav.vue?vue&type=template&id=a5b72cde&scoped=true&"
import script from "./SubtitlesNav.vue?vue&type=script&lang=js&"
export * from "./SubtitlesNav.vue?vue&type=script&lang=js&"
import style0 from "./SubtitlesNav.vue?vue&type=style&index=0&id=a5b72cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b72cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5b72cde')) {
      api.createRecord('a5b72cde', component.options)
    } else {
      api.reload('a5b72cde', component.options)
    }
    module.hot.accept("./SubtitlesNav.vue?vue&type=template&id=a5b72cde&scoped=true&", function () {
      api.rerender('a5b72cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/SubtitlesNav.vue"
export default component.exports